import {
  UserMinusIcon_default
} from "./chunk-KJOQQUQE.mjs";
export {
  UserMinusIcon_default as default
};
